<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                                v-model="employee_id.value.value"
                                                variant="outlined"
                                                label="Select Employee"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                :loading="loading"
                                                :items="getHrmEmployeeList"
                                                :item-title="(item) => `${item.code}-${item.name}` ?? 'N/A'"
                                                :error-messages="employee_id.errorMessage.value"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-account"
                                                item-value="id"
                                                clearable
                                                
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                                        </v-col>
                                        
                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <v-date-input
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="2" md="2" cols="6">
                                            <v-btn class="bg-brand" type="submit" ref="searchButton">
                                                Search
                                            </v-btn                                           >
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Leave Details Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="pa-2">
                                <v-row >

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>

                                            </v-btn-group>
                                        </div>
                                    </v-col>
                                    
                                </v-row>

                                <v-card class="my-2 rounded-md">
                                    <v-card-title class="bg-primary text-white text-center">
                                        <div class="w-100">
                                            <div class="text-h5 font-weight-bold">
                                                {{  titleSetup(from_date.value.value, to_date.value.value) }}
                                            </div>
                                        </div>
                                    </v-card-title>
                                </v-card>

                                <v-data-table
                                :headers="headers"
                                :items="getSchema"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                class="custom-bordered-table"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item="{ item, index }">
                                        <tr>
                                            <td class="text-center">{{ ++index }}</td>
                                            <td class="text-left">{{ item.employee_code }}</td>
                                            <td class="text-left">{{ item.employee_name }}</td>
                                            <td class="text-left">{{ item.leave_type }}</td>
                                            <td class="text-center">{{ item.counted }}</td>
                                            <td class="text-left">{{ item.reason }}</td>
                                            <td class="text-center">
                                                <v-icon
                                                    color="info"
                                                    class="me-2"
                                                    @click="viewItem(item)"
                                                    title="View"
                                                    >
                                                    mdi-eye-outline
                                                </v-icon>
                                            </td>
                                        </tr>
                                    </template>

                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        headers: [
            { title: "#SL", align: "center", key: "index", align: "center", width: "7%", sortable: false },
            { title: "Employee Code", key: "employee_code", align: "center", sortable: false },
            { title: "Employee Name", key: "employee_name", align: "center", sortable: false, },
            { title: "Leave Type", key: "leave_type", align: "center", sortable: false},
            { title: "Day Count", key: "counted", align: "center", sortable: false},
            { title: "Reason", key: "reason", align: "center", sortable: false},
            { title: "Action", key: "action", align: "center", sortable: false},
        ],
    }),

    created(){
        // if(this.$store.getters.getHrmEmployeeList.length == 0){
            this.loading = true;
            this.$store.dispatch('getHrmEmployeeList').then((response) => {
                this.loading = false;
            })
        // };
    },

    watch: {},
    computed: {
        getSchema() {
            return this.$store.getters.getleaveDetailsReport;
        },
        getHrmEmployeeList(){
            return this.$store.getters.getHrmEmployeeList;
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // from_date: yup.date().required().label("From Date"),
                // to_date: yup.date().required().label("To Date"),
            }),
        });

        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const employee_id = useField("employee_id");

        const errorMessages = ref("");
        const loading = ref(false);
        const store = useStore();
        const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            values.employee_id = employee_id.value.value;
            store
                .dispatch("getleaveDetailsReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            from_date,
            to_date,
            employee_id,
            errorMessages,
            loading,
        };
    },

    methods: {
        formattedDate,

        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },

        titleSetup(fromDate, toDate) {
            if (fromDate && toDate) {
                return `Leave Details Report from ${this.formattedDate(fromDate)} to ${this.formattedDate(toDate)}`;
            } else if (fromDate) {
                return `Leave Details Report from ${this.formattedDate(fromDate)}`;
            } else if (toDate) {
                return `Leave Details Report to ${this.formattedDate(toDate)}`;
            } else {
                return `Leave Details Report`;
            }
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = [ "#SL", "Employee code", "Leave Type", "Day Count", "Reason", "Day Status" ];
            const rows = this.getSchema.map((item) => [ serialNumber++, item.employee_code, item.leave_type, item.counted, item.reason, item.day_status ]);
            this.$exportTableToPDF( columns, rows, "Leave Details Report", "leave_details_report_" + this.$fileDate());
        },

        exportToExcel() {
            var data = [["#SL", "code", "Leave Type", "Day Count", "Reason", "Day Status"]];
            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.employee_code, item.leave_type, item.counted, item.reason, item.day_status ]);
            });
            this.$exportTableToExcel(data, "leave_details_report_" + this.$fileDate());
        },
        
        exportToCSV() {
            var data = [["#SL", "code", "Leave Type", "Day Count", "Reason", "Day Status"]];
            var serialNumber = 1;
            this.getSchema.forEach((item) => {
                data.push([ serialNumber++, item.employee_code, item.leave_type, item.counted, item.reason, item.day_status  ]);
            });

            this.$exportTableToCSV(data, "leave_details_report_" + this.$fileDate());
        },
        viewItem(item) {
            this.$store.commit('viewingLeave', item);
            this.$router.push({
                name: "view-leave",
                params: { id: item.leave_id },
            });
        },
    },

    mounted() {
        this.$nextTick(() => {
            // this.$refs.searchButton.$el.click();
            // this.from_date.value.value = new Date();
            // this.to_date.value.value = new Date();
        });   
    },
};
</script>

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}

</style>
